import { messages } from '../../../i18n';

export const fieldInFilterValidationMessage = ({ validation }) =>
  validation?.error?.message?.includes(
    messages.formatString(
      messages.baseChart.validationErrorFieldInFilterOrSlicer,
      '',
    ),
  )
    ? validation?.error?.message
    : null;
